// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getSavingsPlan } from './getSavingsPlan/getSavingsPlan'
import { reducer as setCliente } from './setCliente/setCliente'
import { reducer as clearSavingsPlanSubscription } from './clearSavingsPlanSubscription/clearSavingsPlanSubscription'
import { reducer as getCotizacion } from './getCotizacion/getCotizacion'
import { reducer as removeCotizacion } from './removeCotizacion/removeCotizacion'
import { reducer as updateCotizacion } from './updateCotizacion/updateCotizacion'
import { reducer as setQuotes } from './setQuotes/setQuotes'
import { reducer as setEnableSaveBtn } from './setEnableSaveBtn/setEnableSaveBtn'

const reducers = [
    getSavingsPlan,
    setCliente,
    clearSavingsPlanSubscription,
    getCotizacion,
    removeCotizacion,
    updateCotizacion,
    setQuotes,
    setEnableSaveBtn,
]

export default function reducer( state = initialState, action = '') {
    let newState

    if (action.type === LOGOUT_USER) {
        newState = initialState
    } else {
        newState = state
    }

    return reducers.reduce((s, r) => r(s, action), newState)
}
